module.exports = __webpack_public_path__ + "img/privatization.98ce2b8.png";